import { render, staticRenderFns } from "./UpCourseware.vue?vue&type=template&id=e09b7a52&scoped=true&"
import script from "./UpCourseware.vue?vue&type=script&lang=js&"
export * from "./UpCourseware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09b7a52",
  null
  
)

export default component.exports